// TSS vite/03 §"Query keys".

export const statsKeys = {
    all: ['stats'],
    animal: (id, filters) => ['stats', 'animal', id, filters],
    semen:  (id, filters) => ['stats', 'semen', id, filters],
    lab:    (id, filters) => ['stats', 'lab', id, filters],
    client: (id, filters) => ['stats', 'client', id, filters],
    farm:   (id, filters) => ['stats', 'farm', id, filters],
};
